'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var moduleName = 'appDirectives';

angular.module(moduleName, [])
    .directive('brandHome', ['$rootScope', require('./directives/brand_home')])
    .directive('languageSwitcher', ['$translate', 'Api', require('./directives/language_switcher')])
    .directive('entityShow', ['$location', require('./directives/entity_show')])
    .directive('maExportToCsvButton', require('./directives/export_buttom'))
    .directive('entityEdit', ['$location', require('./directives/entity_edit')])
    .directive('invoiceDownload', ['Restangular', require('./directives/invoice_download')])
    .directive('invoiceResend', ['Restangular', 'FlashService', require('./directives/invoice_resend')])
    .directive('invoicePayment', ['Restangular', 'FlashService', '$location', require('./directives/invoice_payment')])
    .directive('className', ['$rootScope', require('./directives/class_name')])
    .directive('maInputArray', require('./directives/ma_input_array'))
    .directive('maAbilities', ['Restangular', '$timeout', require('./directives/ma_abilities')])
    .directive('menuLink', require('./directives/menu_link'))
    .directive('menuToggle', require('./directives/menu_toggle'))
    .directive('maSwitchField', require('./directives/ma_switch_field'))
    .directive('dashboardSummary', require('./theme/dashboard/sumary.directive'));


exports.default = moduleName;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./js/directives.js
 **/